/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import BlueTransactionsCosts from './BlueTransactionsCosts';
import BlueTransactionsDividends from './BlueTransactionsDividends';
import BlueTransactionsFeesSale from './BlueTransactionsFeesSale';
import BlueTransactionsInterestRent from './BlueTransactionsInterestRent';
import BlueTransactionsLoanRepayment from './BlueTransactionsLoanRepayment';
import BlueTransactionsTransfer from './BlueTransactionsTransfer';

export default function Sublist({ selectedOption, accountId, linkedAttribute, handleCancel, handleCloseAfterSave, transactions, loanAccountsForRepaymentTagging }) {
  Sublist.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: PropTypes.objectOf(PropTypes.any).isRequired,
    accountId: PropTypes.string.isRequired,
    linkedAttribute: PropTypes.object,
    handleCancel: PropTypes.func.isRequired,
    handleCloseAfterSave: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    transactions: PropTypes.arrayOf(PropTypes.object).isRequired,
    loanAccountsForRepaymentTagging: PropTypes.arrayOf(PropTypes.object),
  };
  Sublist.defaultProps = {
    linkedAttribute: {},
    loanAccountsForRepaymentTagging: [],
  };
  // selectedOption is the option selected in the main list of the blue transaction dialog
  // accountId of the account that is currently open in AccountDetails
  // linkedAttribute holds the state of the blue transaction attributes that we are about to set
  const standardProps = {
    selectedOption,
    accountId,
    linkedAttribute,
    handleCancel,
    handleCloseAfterSave,
    // Backward compatibility: some sublist components still expect this prop name.
    handleCloseAfterSale: handleCloseAfterSave,
    transactions,
    loanAccountsForRepaymentTagging,
  };

  switch (selectedOption.id) {
    case 'investment-fees':
    case 'investment-sale':
      return <BlueTransactionsFeesSale {...standardProps} />;
    case 'investment-dividend':
      return <BlueTransactionsDividends {...standardProps} />;
    case 'investment-interest':
    case 'investment-rent':
    case 'investment-pension':
      return <BlueTransactionsInterestRent {...standardProps} />;
    case 'investment-costs':
    case 'investment-contribution':
      return <BlueTransactionsCosts {...standardProps} />;
    case 'investment-transfer':
      return <BlueTransactionsTransfer {...standardProps} />;
    case 'investment-loanRepayment':
      return <BlueTransactionsLoanRepayment {...standardProps} />;
    default:
      return <div />;
  }
}
